module.exports = __webpack_public_path__ + "img/possible-multiday.e52ecb3f.jpg";